// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"02ea7f2d","142":"265c0d8d","162":"c0dd6398"}[chunkId] + ".chunk.js";
};